import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  inputGroupWrapper:{
    flexWrap: "nowrap",
    width: "100%",
    border: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    "&:focus": {
      outline: "none"
    }
  },
  patternFormat: {
    "&:disabled": {
      color: colors.inactiveGrey
    }
  }
}));

export default styles;

export const airlineSelect = {
  menu: base => ({
    ...base,
    // override border radius to match the box
    borderRadius: "8px",
    marginTop: "4px",
    boxShadow: `0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08);`,
    border:`1px solid ${colors.lightGrey}`,
    width:"240px",
    right: 0,
  }),
  option: (base, state) => {
    const displayBorder = () => {
      return state.data.countryPhoneCode &&
        state.options?.length > 2 &&
        state.data.value === 'CA' &&
        !state?.selectProps?.inputValue
    }
    return {
      ...base,
      overflow: 'hidden',
      'img': {
        display: state.isSelected ? 'inline' : 'none',
        marginLeft: "6px"
      },
      display: "flex",
      padding: "10px 8px",
      backgroundColor: state.isSelected ? colors.brightBlue : colors.white,
      borderRadius: "6px",
      color: colors.lightBlack,
      "&:hover": {
        backgroundColor: colors.brightBlue
      },
      "& span": {
        color: colors.mediumGrey,
        marginLeft: "5px",
      },
      "& img": {
        marginLeft: "auto",
      },
      position: 'relative',
      "&::after": {
        content: '""',
        display: 'block',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        borderBottom: displayBorder() ? "1px solid " + colors.lightGrey : "0px transparent",
      }
    }
  },
  control: base => ({
    ...base,
    height:"44px",
    width:"max-content",
    borderWidth: "0px",
    borderRight:"none",
    borderRadius: "8px 8px 8px 8px",
    borderColor: colors.darkGrey,
    "&:hover": {
      borderColor: colors.darkGrey,
    },
    // Removes weird border around container
    boxShadow: null,
    minHeight: '40px',
    paddingRight: "14px",
  }),
  valueContainer: base => ({
    ...base,
    padding: "0px",
    height:"44px",
    marginLeft:"12px"
  }),
  input: base =>({
    ...base,
    height:"44px",
    minWidth:"40px",
    margin:"0px",
    padding:"0px",
  }),
  singleValue: base => ({
    ...base,
    marginLeft:"0px",
    marginRight:"8px",
    padding: "0px",
    color: colors.lightBlack,
  }),
  indicatorSeparator: base => ({
    ...base,
    display:"none"
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding:"0",
    color: colors.inactiveGrey,
    "&:hover": {
      color: colors.inactiveGrey
    }
  }),
  indicatorsContainer: (base) => ({
    ...base,
    width:"20px"
  })
}

export const disabledStyles = {
  ...airlineSelect,
  control: (base, state) => ({
    ...base,
    background: `${colors.brightBlue} !important`,
    border:"none",
    borderRadius: "8px 8px 8px 8px",
    color: `${colors.inactiveGrey} !important`,
    "& input": {
      color: `${colors.inactiveGrey} !important`,
    },
    // Removes weird border around container
    boxShadow: null,
    minHeight: '40px',
    maxHeight: "44px"
  }),
  singleValue: base => ({
    ...base,
    color: `${colors.inactiveGrey} !important`,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0",
  }),
}